import React, { useEffect, useCallback } from "react";

import * as Styled from "./TitleComponent.styles";
import { isDesktop } from "utils/platform";
import useGlobalStore from "utils/store";
import HandIconImage from "assets/img/mouse-icon.png";

import { APP_EVENTS, EventsManager } from "webgl/events/EventsManager";
import { ScenesManager } from "webgl/scenes/ScenesManager";

import { fadeMotionProps } from "utils/styles/animations";

export interface TitleComponentProps {
	onCompleteLoad: () => void;
}

const TitleComponent: React.FC<TitleComponentProps> = ({ onCompleteLoad }) => {
	const { showUI, copy } = useGlobalStore();

	const goToHome = useCallback(() => {
		if (showUI) return
		// SoundController.playAudio(SOUND_LABELS.MAIN);
		EventsManager.instance.trigger(APP_EVENTS.OUTLINE_SHOW);
		onCompleteLoad();
	}, [onCompleteLoad, showUI]);

	useEffect(() => {

		if (ScenesManager.debugMode) {
			goToHome();
		}

		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Styled.Wrapper id="titleComponentID" {...fadeMotionProps}>
			<Styled.Content
				// {...handlers}				
				className={!showUI ? "initialState" : "finalState"}>
				<Styled.ContentTitle
					className={!showUI ? "initialState" : "finalState"}
					dangerouslySetInnerHTML={{
						__html: isDesktop()
							? copy.landingScreen.title
							: copy.landingScreen.titleMobile,
					}}
				/>

				<Styled.ContentSubtitle
					dangerouslySetInnerHTML={{
						__html: copy.homeScreen.subtitle,
					}}
					className={!showUI ? "initialState" : "finalState"}
				/>


					<Styled.ButtonStart
						onClick={goToHome}
						style={showUI? {cursor: "auto"} : {}}
						className={!showUI ? "initialState" : "finalState"}
						>						
						<img
							src={HandIconImage}
							alt={
								isDesktop()
									? copy.landingScreen.cta
									: copy.landingScreen.ctaMobile
							}
						/>
						<Styled.ButtonStartText
							dangerouslySetInnerHTML={{
								__html: isDesktop()
									? copy.landingScreen.cta
									: copy.landingScreen.ctaMobile,
							}}
						/>
					</Styled.ButtonStart>
				
			</Styled.Content>

			<Styled.Disclaimer
				className={!showUI ? "initialState" : "finalState"}
				dangerouslySetInnerHTML={{
					__html: copy.landingScreen.disclaimer,
				}} />
		</Styled.Wrapper>
	);
};

export default TitleComponent;
